import BaseModulePlugins from '@/store/baseModule/plugins';
//import registerTabModule from '@/store/TabModule';
import alertsModule from '@/store/modules/alerts/module';
import {
  UntreatedAlertsService,
  getSensorsQuality,
  getEnergyCases,
} from '@/services/services/alerts.service';

const UNTREATED_ALERTS_MODULE_NAME = ['alerts', 'untreated'];
const UNTREATED_ALERTS_MODULE_PATH = UNTREATED_ALERTS_MODULE_NAME.join('/');
export { UNTREATED_ALERTS_MODULE_NAME, UNTREATED_ALERTS_MODULE_PATH };

export default (store) => {
  store.registerModule(
    UNTREATED_ALERTS_MODULE_NAME,
    alertsModule(UntreatedAlertsService)
  );

  const basePlugin = new BaseModulePlugins({
    module: UNTREATED_ALERTS_MODULE_PATH,
    store,
  });

  basePlugin.initAttributeFiltersWhenAttributesObjRefIsLoaded({});

  basePlugin.onInit(() => {
    basePlugin.loadItemsOnCurrentEntityChange();
    store.subscribe((mutation) => {
      if (mutation.type === 'entities/SET_CURRENT') {
        store.dispatch(`${UNTREATED_ALERTS_MODULE_PATH}/setGlobalSearch`, null);
      }
    });
    basePlugin.persistVuexMutationsToLocalStorage(['SET_ATTRIBUTES_OBJ']);

    basePlugin.onItemAddedOrModified(() => {
      store.dispatch(`${UNTREATED_ALERTS_MODULE_PATH}/refreshItems`);
    }, 'actionplans');

    basePlugin.onItemsLoaded((items) => {
      const idList = items.map((item) => item.property_id);
      getSensorsQuality(items)
        .then(async (resultList) => {
          store.commit('alerts/untreated/SET_SENSORS_QUALITY', resultList);
        })
        .catch((err) => {
          store.dispatch('snackbar/setError', err);
        });
      getEnergyCases(idList)
        .then(async (resultList) => {
          store.commit('alerts/untreated/SET_ENERGY_CASES', resultList);
        })
        .catch((err) => {
          store.dispatch('snackbar/setError', err);
        });
    });
  });
};
